'use strict';

import { getUrlParameter } from '../../../utils/utils';

const DynamicResourceComponent = {
    data() {
        return {
            resourceFilterBannerSimpleId: null
        }
    },
    methods: {
        getHashFilters() {
            const rawFilters = getUrlParameter(`resource-filter-${this.resourceFilterBannerSimpleId}`, { hash: true });
            let filters = [];

            if (rawFilters) {
                filters = rawFilters.replace('[', '').replace(']', '').split(',');
            }

            return filters.filter(String);
        },
        getHashResourcePage(simpleId) {
            return getUrlParameter(`resource-${simpleId}-page`, { hash: true });
        },
        updateHashKey(hashData) {
            const hashModel = [];
            let hashes = window.location.hash.substring(1);

            if (hashes) {
                hashes = hashes.split('&');
                hashes = hashes.map(hash => hash.split('='));

                hashes.forEach(hash => hashModel.push({
                    key: hash[0],
                    value: hash[1]
                }));
            }

            if (!hashes
                || !hashes.length
                || !hashes.some(hash => hash[0] === hashData.key)) {
                    hashModel.push({
                        key: hashData.key,
                        value: hashData.value
                    });
            }
            
            let hashNewValue = hashData.newValue;

            if (hashData.asArray) {
                hashNewValue = `[${hashData.newValue}]`;
            }

            const foundKey = hashModel.find(hash => hash.key === hashData.key);

            if (!foundKey) {
                return;
            }

            foundKey.value = hashNewValue;

            const newHash = hashModel.map(hash => `${hash.key}=${hash.value}`).join('&');

            window.location.hash = newHash;
        }
    }
};

export default DynamicResourceComponent;